import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
    


<div className="pt-b3">
    <div className="func">
        
            

            
                <a href="#" className="bttn bttn-scroll" color="black" dir="top"><span className="icon"></span></a>
            
        

    </div>
    <div className="footer-inner">

        <div className="footer-wrap">
            <div className="container footer__top">
                <div className="row">
                    <div className="col-9">
                        <ul className="fd-list btn1-en">
                            <li className="fd-item">
                                <a onclick="setTagging('footer_whoweare')" href="/company" className="fd-link btn3-en" data-cursor="click">Company</a>
                                <div className="fd2-wrap">
                                    <ul className="fd2-list">
                                           <li className="fd2-item"><a className="fd2-link btn4-kr trn" data-cursor="click" target="_self" href="/about-us">About Us</a></li>
                                            <li className="fd2-item"><a className="fd2-link btn4-kr trn" data-cursor="click" target="_self" href="/evolution">Evolution</a></li>
                                            <li className="fd2-item"><a className="fd2-link btn4-kr trn" data-cursor="click" target="_self" href="/our-motivators">Leadership</a></li>
                                            <li className="fd2-item"><a className="fd2-link btn4-kr trn" data-cursor="click" target="_self" href="/clientele">Clientele</a></li>
                                            <li className="fd2-item"><a className="fd2-link btn4-kr trn" data-cursor="click" target="_self" href="/partners">Partners</a></li>
                                            <li className="fd2-item"><a className="fd2-link btn4-kr trn" data-cursor="click" target="_self" href="/quality-and-accreditations">Quality and Accreditations</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li className="fd-item">
                                <a href="/core-competencies" className="fd-link btn3-en" data-cursor="click">Core Competencies</a>
                                <div className="fd2-wrap">
                                    <ul className="fd2-list">
                                     <li className="fd2-item"><a className="fd2-link btn4-kr trn" data-cursor="click" target="_self" href="/competencies/advanced-avionics-solutions">Advanced Avionics Solutions</a></li>
                  <li className="fd2-item"><a className="fd2-link btn4-kr trn" data-cursor="click" target="_self" href="/competencies/select-custom-solutions">Select Custom Solutions</a></li>
                  <li className="fd2-item"><a className="fd2-link btn4-kr trn" data-cursor="click" target="_self" href="/competencies/precise-time-and-frequency-solutions">Precise Time &amp; Frequency Solutions</a></li>
                  <li className="fd2-item"><a className="fd2-link btn4-kr trn" data-cursor="click" target="_self" href="/competencies/control-solutions">Control Solutions</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li className="fd-item">
                                <a href="/industries" className="fd-link btn3-en" data-cursor="click">Industries</a>
                                <div className="fd2-wrap">
                                    <ul className="fd2-list">
                                       <li className="fd2-item"><a className="fd2-link btn4-kr trn" data-cursor="click" target="_self" href="/industries/space">Space</a></li>
                  <li className="fd2-item"><a className="fd2-link btn4-kr trn" data-cursor="click" target="_self" href="/industries/sea">Sea</a></li>
                  <li className="fd2-item"><a className="fd2-link btn4-kr trn" data-cursor="click" target="_self" href="/industries/land">Land</a></li>
                  <li className="fd2-item"><a className="fd2-link btn4-kr trn" data-cursor="click" target="_self" href="/industries/air">Air</a></li>
                                        
                                    </ul>
                                </div>
                            </li>
                            <li className="fd-item">
                                <a href="/services" className="fd-link btn3-en" data-cursor="click">Services</a>
                                <div className="fd2-wrap">
                                    <ul className="fd2-list">
                                         <li className="fd2-item">
                    <a className="fd2-link btn4-kr trn" data-cursor="click" target="_self" href="/concept-to-realization-of-futuristic-products">Concept to Realization of Futuristic Products
                    </a>
                  </li>
                  <li className="fd2-item"><a className="fd2-link btn4-kr trn" data-cursor="click" target="_self" href="/legacy-upgrade">Legacy Upgrade</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li className="fd-item">
                                <a href="/sustainability" className="fd-link btn3-en" data-cursor="click">Sustainability</a>
                                <div className="fd2-wrap">
                                    <ul className="fd2-list">
                                          <li className="fd2-item"><a className="fd2-link btn4-kr trn" data-cursor="click" target="_self" href="/make-in-india">Make in India</a></li>
                  <li className="fd2-item"><a className="fd2-link btn4-kr trn" data-cursor="click" target="_self" href="/safety-first">Safety First</a></li>
                  <li className="fd2-item"><a className="fd2-link btn4-kr trn" data-cursor="click" target="_self" href="/investing-on-people">Investing on People</a></li>

                  <li className="fd2-item"><a className="fd2-link btn4-kr trn" data-cursor="click" target="_self" href="/environmental-safety">Environmental Safety</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li className="fd-item">
                                <a href="/careers" className="fd-link btn3-en" data-cursor="click">Careers</a>
                              
                            </li>

                              <li className="fd-item">
                                <a href="/contact" className="fd-link btn3-en" data-cursor="click">Contact</a>
                                <div className="fd2-wrap">
                                    <ul className="fd2-list">
                                        <li className="fd2-item"><a className="fd2-link btn4-kr trn" data-cursor="click" target-page="talent" data-trn-key="common-28" href="mailto:info@parkcontrols.com">info@parkcontrols.com</a></li>
                                        <li className="fd2-item"><a className="fd2-link btn4-kr trn" data-cursor="click" target-page="recruit" data-trn-key="common-30" href="tel:+918025292513">+91-80-2529 2513/2529 7199/ 2529 3482</a></li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>


                        </div>
                    </div>
                    <div className="footer__bot util container">
                        <div className="">
                            <ul className="fd-list--util">
                                <li className="fd-item">
                                    <a href="/privacy-policy" className="fd-link btn4-kr trn" data-cursor="click" data-trn-key="common-33">Privacy Policy</a>
                                </li>
                                <li className="fd-item">
                                    <a href="/terms-of-service" className="fd-link btn4-kr trn" data-cursor="click" data-trn-key="common-32">terms of service</a>
                                </li>
                                
                                
                            </ul>
                            <p className="c1 copyright" >#2716, Suranjan Das Rd, HAL 3rd Stage, Bhoomi Reddy Colony, New Tippasandra, Bengaluru, Karnataka 560075. Copyright © 2026 <span className="cp-name">Mystra.in</span> All Rights Reserved.</p>
                        </div>
                        <ul className="social">
                              {/* <!-- <li className="social__item"><a onclick="setTagging('footer_goto_blog')" className="social__link social__link--blog" href="https://blog.naver.com/haspr" target="_blank" data-cursor="click">></a></li> --> */}
                            <li className="social__item"><a className="social__link social__link--facebook" href="https://www.facebook.com" target="_blank" data-cursor="click"></a>
                            </li>
                            <li className="social__item"><a className="social__link social__link--youtube" href="https://www.youtube.com/" target="_blank" data-cursor="click"></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </footer>
  );
};

export default Footer;